"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getName = exports.filterNonImage = exports.filterImage = exports.IMAGETYPE = exports.CImage = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let IMAGETYPE = exports.IMAGETYPE = /*#__PURE__*/function (IMAGETYPE) {
  IMAGETYPE["RAW"] = "raw";
  IMAGETYPE["PROCESSED"] = "processed";
  return IMAGETYPE;
}({});
;
const getName = image => {
  return image.name ? image.name : `[${image.imageId}]`;
};
exports.getName = getName;
class CImage {
  constructor() {
    _defineProperty(this, "imageId", null);
    // unique identifier
    _defineProperty(this, "name", null);
    _defineProperty(this, "modifiedAt", null);
    // timestamp of the last modification
    //imageType: IMAGETYPE | null = null; // the type of the image
    //pathToRaw: string | null = null; // path to the raw file in the storage
    //pathToProcessed: string | null = null; // path to the processed file in the storage
    _defineProperty(this, "caption", null);
    // title of the source
    _defineProperty(this, "alt", null);
    // alt text of the image
    _defineProperty(this, "prompt", null);
  } // prompt of the image
}
exports.CImage = CImage;
;
;
const optionalKeys = [
// enter the key of the interface that is not in the class
'files', 'isDirty'];

/**
* The type of an array of the properties
*/

/**
* An array of the properties
*/
const propsArray = Object.keys(new CImage());

/* multiple parent classes
export const propsArray: ArrImage = [
   ...Object.keys(new CImage()),
   ...Object.keys(new C_MULTIPLE1_()),
   ...Object.keys(new C_MULTIPLE2_()),
] as ArrImage;*/

/**
* Get the properties from a bigger object
* when collect==true, then also collect the optional keys that are only defined in the interface but not in the class
*/
const filterImage = (props, {
  fallback = {},
  override = {}
} = {}, collect = false) => {
  const data = Object.assign(propsArray.concat(collect ? optionalKeys : []).reduce((r, k) => {
    // do not overwrite the IEntry values with undefined
    return _objectSpread(_objectSpread({}, r), {}, {
      [k]: function (_props$k, _props$k$localeCompar) {
        if (props[k] !== undefined && ((_props$k = props[k]) === null || _props$k === void 0 || (_props$k$localeCompar = _props$k.localeCompare) === null || _props$k$localeCompar === void 0 ? void 0 : _props$k$localeCompar.call(_props$k, '')) !== 0) {
          return props[k];
        }
        if (fallback[k] !== undefined) {
          return fallback[k];
        }
        if (r[k] !== null) {
          return r[k];
        }
        return undefined;
      }()
    });
  }, new CImage()), override);
  return data;
};
exports.filterImage = filterImage;
const filterNonImage = props => Object.keys(props).reduce((r, k) => {
  return Object.assign(r, !propsArray.includes(k) ? {
    [k]: props[k]
  } : {});
}, {});
exports.filterNonImage = filterNonImage;